<div class="container-fluid">
  <div class="row ">
    <div class="col-md-12">
        <img src="assets/images/logo.png">
      
        </div>
        </div>

        <div class="row h-100">
          <div class="col-md-6 mx-auto text-center">
            <h1>Page Not Found!!</h1> 
            <img src="assets/images/not.png" class="w-100">
          </div>
        </div>
        </div>